// @flow
import * as React from 'react';
import PropTypes from 'prop-types';
import {Hidden, makeStyles, Typography} from '@material-ui/core';
import {colors} from '../../../../assets/styles/colors';
import Tooltip from './Tooltip';

type Props = {
  icon?: string,
  title: string,
  content: React.Node,
  tooltip?: string,
};

const useStyles = makeStyles(theme => ({
  card: {
    width: '100%',
    background: '#FFFFFF',
    boxShadow:
      '0px 0px 1px rgba(181, 181, 181, 0.2), 0px 2px 8px rgba(209, 209, 209, 0.16)',
    borderRadius: '8px',
    padding: theme.spacing(1.5, 2),
  },
  cardContent: {
    display: 'flex',
    flexDirection: 'column',
  },
  cardHeader: {
    padding: theme.spacing(0.5, 0),
    display: 'flex',
    alignItems: 'center',
    [theme.breakpoints.down('md')]: {
      justifyContent: 'space-between',
    },
  },
  icon: {
    marginRight: theme.spacing(1),
  },
  title: {
    color: colors.grey900,
    fontSize: 14,
    fontWeight: 500,
  },
  titleHeader: {
    width: '100%',
    alignItems: 'center',
    display: 'flex',
  },
  cardBody: {
    display: 'flex',
    alignItems: 'center',
    flexWrap: 'wrap',
    padding: theme.spacing(0.5, 0),
    width: '100%',
    [theme.breakpoints.down('md')]: {
      justifyContent: 'space-between',
    },
  },
}));
export default function StatsCard(props: Props) {
  const {icon, title, content, tooltip} = props;
  const classes = useStyles();
  return (
    <div className={classes.card}>
      <div className={classes.cardContent}>
        <div className={classes.cardHeader}>
          <div className={classes.titleHeader}>
            {icon && <img className={classes.icon} src={icon} alt="" />}
            <Hidden smDown>
              <Typography className={classes.title}>{title}</Typography>
            </Hidden>
          </div>
          {tooltip && <Tooltip title={tooltip} />}
        </div>
        <div className={classes.cardBody}>
          <Hidden mdUp>
            <Typography className={classes.title}>{title}</Typography>
          </Hidden>
          {content}
        </div>
      </div>
    </div>
  );
}

StatsCard.propTypes = {
  icon: PropTypes.string,
  title: PropTypes.string.isRequired,
  content: PropTypes.node,
  tooltip: PropTypes.string,
};
